import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "count"];

  addInputs() {
    this.addBatch("input");
  }

  addOutputs() {
    this.addBatch("output");
  }

  addBatch(direction) {
    const count = this.batchCount();
    let nextIndex = this.nextNameIndex(direction);

    for (let i = 0; i < count; i++) {
      const row = this.insertRow();
      this.setDirection(row, direction);
      this.setName(row, `${this.label(direction)} ${nextIndex}`);
      nextIndex += 1;
    }

    this.resetCount();
  }

  batchCount() {
    if (!this.hasCountTarget) return 1;
    const value = parseInt(this.countTarget.value, 10);
    if (Number.isNaN(value) || value < 1) return 1;
    return Math.min(value, this.maxCount());
  }

  maxCount() {
    if (!this.hasCountTarget) return 8;
    const max = parseInt(this.countTarget.max, 10);
    return Number.isNaN(max) ? 8 : max;
  }

  resetCount() {
    if (this.hasCountTarget) this.countTarget.value = "1";
  }

  insertRow() {
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);
    this.containerTarget.insertAdjacentHTML("beforeend", html);
    return this.containerTarget.lastElementChild;
  }

  setDirection(row, direction) {
    const select = row.querySelector('select[name*="[direction]"]');
    if (!select) return;
    select.value = direction;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  setName(row, name) {
    const input = row.querySelector('input[name*="[name]"]');
    if (input) input.value = name;
  }

  label(direction) {
    return direction === "output" ? "Output" : "Input";
  }

  nextNameIndex(direction) {
    const existingRows = this.containerTarget.querySelectorAll('[data-nested-form-target="row"]');
    let count = 0;
    for (const row of existingRows) {
      if (row.style.display === "none") continue;
      const directionSelect = row.querySelector('select[name*="[direction]"]');
      if (directionSelect?.value === direction) count += 1;
    }
    return count + 1;
  }
}
